const name = "G. Luce Srl"
const email = "info@gluce.it"
const street = "viale Brianza 20";
const city = "20823 Lentate sul Seveso (MB)";
const country = "Italia";
const VAT = "08178020965";
const phone = "+39 0362 566038"
const fax = "+39 0362 567243"
const numero_verde = "--- --- ---"


export { name, email, street, city, country, VAT, phone, fax, numero_verde }